import type { Time } from "~/tools/date-time/time";
import type { Destructor } from "~/tools/destructor";
import { max } from "~/tools/max";

/**
 * Executes a callback function at specified intervals.
 *
 * @param callback - The function to be executed at each interval.
 * @param interval - The interval duration in milliseconds.
 *
 * @returns A cleanup function that can be used to cancel the interval.
 */
export function onInterval(callback: (now: Time) => void, interval: number): Destructor {
	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	const timeoutId = window.setInterval(() => callback(Date.now()), max(0, interval));

	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	return () => window.clearInterval(timeoutId);
}
